import himg1 from '../images/service-single/1.jpg'
import himg2 from '../images/service-single/2.jpg'
import himg3 from '../images/service-single/3.jpg'
import cimg from '../images/service-single/4.jpg'
import mimg from '../images/service-single/5.jpg'
import eimg from '../images/service-single/6.jpg'
import mentorship_3 from '../images/service-single/mentorship/mentorships_3.jpeg'
import ptimg from '../images/service-single/8.jpg'
import rhimg from '../images/service-single/9.jpg'
import youthc from '../images/service-single/youth-camps/youth-camps.jpg'
import mentorship_1 from '../images/service-single/mentorship/mentorships_1.jpg'
import mentorship_2 from '../images/service-single/mentorship/mentorships_2.jpg'

import role_models_1 from '../images/role_models_1.jpg'


import ocimg from '../images/service-single/10.jpg'
import ocimg2 from '../images/service-single/11.jpg'
import ocimg3 from '../images/service-single/12.jpg'
import ocimg4 from '../images/service-single/13.jpg'
import ocimg5 from '../images/service-single/14.jpg'

import tutoring_1 from '../images/service-single/tutoring/tutoring_2.jpg'
import tutoring_2 from '../images/service-single/tutoring/tutoring_1.jpg'
import tutoring_3 from '../images/service-single/tutoring/tutoring_3.jpg'

import counseling_1 from '../images/service-single/counseling/counseling_1.jpg'
import counseling_2 from '../images/service-single/counseling/counseling_2.jpg'
import counseling_3 from '../images/service-single/counseling/counseling_3.jpg'


import wpimg4 from '../images/service-single/wp1.jpg'
import wpimg5 from '../images/service-single/wp2.jpg'

import ntimg1 from '../images/service-single/18.jpg'
import ntimg2 from '../images/service-single/20.jpg'
import ntimg3 from '../images/service-single/19.jpg'

import ntimg4 from '../images/service-single/nt1.jpg'
import ntimg5 from '../images/service-single/nt2.jpg'


import picon1 from '../images/icon/1.png'
import picon2 from '../images/icon/2.png'
import picon3 from '../images/icon/3.png'

import img1 from '../images/service-single/summer-camp.jpeg'
import img2 from '../images/service-single/winter-camp-2.jpeg'
import img3 from '../images/service-single/tent-camp-2.jpeg'

import rowan_trip from '../images/service-single/college_trips/rowan_trip.jpeg'
import villanova_trip from '../images/service-single/college_trips/villanova_trip.jpg'
import drexel_trip from '../images/service-single/college_trips/drexel_trip.jpg'
import penn_trip from '../images/service-single/college_trips/penn_trip.jpg'

import sat_1 from '../images/service-single/sat_prep/sat_1.jpg'
import sat_2 from '../images/service-single/sat_prep/sat_2.jpg'
import sat_3 from '../images/service-single/sat_prep/sat_3.jpg'

import winterCamp_1 from '../images/service-single/winter_camp/winterCamp_1.jpg'
import winterCamp_2 from '../images/service-single/winter_camp/winterCamp_2.jpg'
import winterCamp_3 from '../images/service-single/winter_camp/winterCamp_3.jpg'

import tentCamp_1 from '../images/service-single/tent_camp/tentCamp_1.jpg'
import tentCamp_2 from '../images/service-single/tent_camp/tentCamp_2.jpg'
import tentCamp_3 from '../images/service-single/tent_camp/tentCamp_3.jpg'

import summerCamp_1 from '../images/service-single/summer_camp/summerCamp_1.jpg'
import summerCamp_2 from '../images/service-single/summer_camp/summerCamp_2.jpg'
import summerCamp_3 from '../images/service-single/summer_camp/summerCamp_3.jpg'

import mentorTrain from '../images/service-single/mentor_training/mentor-training.jpg'

import essay_1 from '../images/service-single/essay_camp/essay_1.jpg'
import essay_2 from '../images/service-single/essay_camp/essay_2.jpg'
import essay_3 from '../images/service-single/essay_camp/essay_3.jpg'

import convention_1 from '../images/service-single/mentor_training/convention.jpg'
import convention_2 from '../images/service-single/mentor_training/convention-2.jpg'
import convention_3 from '../images/service-single/mentor_training/convention_2.jpg'



import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPersonChalkboard} from '@fortawesome/free-solid-svg-icons'
import {faBuildingColumns} from '@fortawesome/free-solid-svg-icons'
import {faPeopleGroup} from '@fortawesome/free-solid-svg-icons'
import {faHouseLaptop} from '@fortawesome/free-solid-svg-icons'
import {faGraduationCap} from '@fortawesome/free-solid-svg-icons'
import {faPenToSquare} from '@fortawesome/free-solid-svg-icons'
import {faBus} from '@fortawesome/free-solid-svg-icons'
import {faSquareRootVariable} from '@fortawesome/free-solid-svg-icons'
import {faPeopleArrows} from '@fortawesome/free-solid-svg-icons'
import {faLightbulb} from '@fortawesome/free-solid-svg-icons'
import {faCampground} from '@fortawesome/free-solid-svg-icons'
import {icon} from '@fortawesome/fontawesome-svg-core'

let icon1 = <FontAwesomeIcon icon={faPersonChalkboard} />
let icon2 = <FontAwesomeIcon icon={faBuildingColumns} />
let icon3 = <FontAwesomeIcon icon={faPeopleGroup} />
let icon4 = <FontAwesomeIcon icon={faHouseLaptop} />
let icon5 = <FontAwesomeIcon icon={faGraduationCap} />
let icon6 = <FontAwesomeIcon icon={faPenToSquare} />
let icon7 = <FontAwesomeIcon icon={faBus} />
let icon8 = <FontAwesomeIcon icon={faSquareRootVariable} />
let icon9 = <FontAwesomeIcon icon={faPersonChalkboard} />
let icon10 = <FontAwesomeIcon icon={faPeopleArrows} />
let icon11 = <FontAwesomeIcon icon={faLightbulb} />
let icon12 = <FontAwesomeIcon icon={faCampground} />



const Services = [
    {
        id: 'academic-counseling',
        icon: icon1,
        title:'Academic Counseling',
        description: 'I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.',
        simg1:himg1,
        simg2:himg2,
        simg3:himg3,
    },
    {
        id: 'education',
        icon:icon2,
        title:'Educational Development',
        description:'I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.',
        simg1:cimg,
        simg2:himg2,
        simg3:himg3,
    },
    {
        id: 'mentorship',
        icon:icon3,
        title:'Mentorship Program',
        description:'I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.',
        simg1:mimg,
        simg2:himg2,
        simg3:himg3,
    },
    {
        id: '4',
        icon: icon4,
        //home schooling in 2 lines
        title: 'Home \nSchooling',
        description:'I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful.',
        simg1:eimg,
        simg2:himg2,
        simg3:himg3,
    },
    {
        id: 'weekly-mentorship',
        icon: icon10,
        title:'Weekly Mentorship',
        description: 'Empowering students with guidance, support, and life skills to grow academically, spiritually, and personally.',
        longDescription: 'Our Weekly Mentorship program pairs college student mentors with middle schoolers and high schoolers to support their academic and spiritual growth. These dedicated mentors meet with their mentees weekly, providing guidance, encouragement, and friendship. The program includes interactive sessions, study groups, and sleepovers that strengthen bonds and create a sense of community. Through this consistent support, mentees gain valuable insights, improve their skills, and grow in their spiritual journeys. Join our Weekly Mentorship program to experience the positive impact of peer guidance and build meaningful relationships that inspire success and personal growth.',
        simg1:mentorship_3,
        simg2:mentorship_1,
        simg3:mentorship_2,
    },
    {
        id: 'role-models',
        icon: icon11,
        title:'Role Models',
        description:'Inspiring future leaders by fostering growth, responsibility, and mentorship skills in outstanding students.',
        longDescription: 'Our Role Models program identifies outstanding mentees and prepares them to become mentors in future years. By recognizing the potential and leadership qualities in middle schoolers and high schoolers, we empower them to take on mentoring roles as they progress into college. This initiative not only fosters personal growth and responsibility but also ensures the continuity of our supportive community. Selected mentees receive additional training and opportunities to develop their leadership and mentoring skills. Join our Role Models program to inspire and be inspired, creating a cycle of positive influence and guidance for future generations.',
        simg1:role_models_1,
        //simg2:wimg2,
        //simg3:wimg2,
    },
    {
        id: 'youth-camps',
        icon: icon12,
        title:'Youth Camps',
        description: 'Transformative camps that build skills, friendships, and spiritual growth for all ages.',
        longDescription: 'Our Youth Camps offer students immersive experiences that encourage personal, spiritual, and leadership growth. From our Summer Camp focused on building essential life skills and friendships, to our Tent Camp that connects participants with nature, and our cozy Winter Camp providing a warm retreat, each program is designed to inspire and develop resilient, compassionate young leaders. Through engaging activities, group workshops, and meaningful connections, participants gain confidence and cultivate values that last a lifetime. Join our Youth Camps for an unforgettable journey of growth, community, and self-discovery.',
        simg1:youthc,
        //simg2:wimg2,
        //simg3:wimg2,
    },
    {
        id: '8',
        fIcon1:'flaticon-dolphin',
        title:'Ocean Protection',
        description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
        simg1:ocimg,
        simg2:ocimg4,
        simg3:ocimg5,
    },
    {
        id: '9',
        fIcon1:'flaticon-whale',
        title:'Saving Whale',
        description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
        simg1:ocimg2,
        simg2:ocimg4,
        simg3:ocimg5,
    },
    {
        id: '10',
        fIcon1:'flaticon-fish',
        title:'Reducing Hunting',
        description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
        simg1:ocimg3,
        simg2:ocimg4,
        simg3:ocimg5,
    },
    {
        id: '11',
        fIcon1:picon1,
        title:'Wash Your Hands',
        description:'Lorem ipsum dolor sit amet econsectetur adipiscin.',
        simg1:tutoring_1,
        simg2:wpimg4,
        simg3:wpimg5,
    },
    
    {
        id: 'college-counseling',
        icon:icon5,
        title:'College Counseling',
        description:'Personalized 1-on-1 guidance to help high school students set goals, plan for college, and build skills for future success.',
        longDescription: 'At our program, we offer personalized 1-on-1 sessions with high schoolers, covering a wide range of topics essential for their academic and personal development. From goal setting and transcript planning to admission test guidance and career counseling, our experienced mentors provide tailored support to help students navigate their educational journey with confidence. We also offer guidance on extracurricular and volunteer activities, summer programs, and passion projects, empowering students to showcase their unique interests and talents. Additionally, our mentors assist in crafting a well-rounded college list, ensuring students find the perfect fit for their academic and career aspirations. Join us as we provide comprehensive support to high school students, helping them succeed academically and prepare for a bright future.',
        simg1:counseling_1,
        simg2:counseling_2,
        simg3:counseling_3,
    },
    {
        id: 'essay-bootcamp',
        icon: icon6,
        title:'College Essay Bootcamp',
        description:'Guidance and strategies to help high school students craft impactful college application essays that showcase their unique stories and strengths.',
        longDescription:'Join our college essay boot camp and gain the edge you need to stand out in the competitive college admissions process. Our expert-led program provides high school students with personalized guidance and proven strategies for crafting compelling application essays that captivate admissions committees. Through interactive workshops, individualized coaching sessions, and targeted feedback, students learn to articulate their unique experiences, passions, and aspirations effectively. With our comprehensive approach, we empower students to create essays that not only showcase their authentic selves but also demonstrate their readiness for success in higher education. Don\'t miss this opportunity to elevate your application and maximize your chances of admission to your dream college.',
        simg1:essay_1,
        simg2:essay_2,
        simg3:essay_3,
    },
    {
        id: 'college-visit',
        icon: icon7,
        title:'College Visits',
        description:'Invaluable campus tours and insights to help students make informed college choices and envision their academic futures.',
        longDescription:'At our college visit events, we provide high school students with invaluable opportunities to explore various campuses and gain firsthand insights into the college experience. Guided by experienced mentors, students embark on immersive tours of esteemed institutions, including campus facilities, academic departments, and student life areas. Through engaging sessions and interactions with current students and faculty, participants gain a deeper understanding of each college\'s unique culture, academic programs, and extracurricular opportunities. Our college visit events are designed to help students make informed decisions about their higher education journey, empowering them to envision their future academic pathways with clarity and confidence. Join us as we open doors to endless possibilities and guide students toward finding their perfect fit in higher education.',
        simg1:penn_trip,
        simg2:rowan_trip,
        simg3:drexel_trip,
    },
    {
        id: 'sat-prep',
        icon: icon8,
        title:'SAT Prep',
        description:'Comprehensive SAT prep that equips students with essential skills and effective strategies needed to succeed on the exam.',
        longDescription:'At our SAT Prep events, we offer comprehensive and personalized preparation to help students excel in their SAT exams. Our experienced instructors provide targeted instruction on all sections of the SAT, including math, reading, writing, and essay writing. Through a combination of interactive lectures, practice tests, and one-on-one tutoring sessions, we equip students with the strategies and skills needed to tackle the exam with confidence. Our curriculum is designed to cater to students of all levels, from beginners to advanced, ensuring that each student receives individualized attention and support. Whether students are aiming to improve their scores or aiming for a perfect score, our SAT Prep events provide the resources and guidance necessary for success. Join us as we empower students to achieve their highest potential on the SAT and unlock opportunities for their academic future.',
        simg1:sat_1,
        simg2:sat_2,
        simg3:sat_3,

    },
    {
        id: 'academic-tutoring',
        icon: icon9,
        title:'Academic Tutoring',
        description:'Focused support to help high school students excel in SAT prep and academics through targeted guidance and mentorship.',
        longDescription: 'At our program, we prioritize student success by providing a supportive environment for high schoolers to excel in their SAT preparation or schoolwork. As mentors, we understand the challenges students face and offer personalized guidance to help them overcome obstacles. Whether tackling SAT math problems or mastering complex subjects, our experienced mentors provide expert assistance and encouragement every step of the way. Through targeted support and individualized attention, we empower students to achieve their academic goals with confidence. Join us as we foster a culture of learning and growth, where students thrive academically and unlock their full potential.',
        simg1:tutoring_1,
        simg2:tutoring_2,
        simg3:tutoring_3,
    },
    {
        id: 'summer-camps',
        // icon: icon9,
        title: 'Summer Camps',
        description: 'Focused support to help high school students excel in SAT prep and academics through targeted guidance and mentorship.',
        longDescription: 'Our Summer Camp is an enriching experience designed to provide middle schoolers, high schoolers, and college students with a strong spiritual foundation. This camp offers a unique opportunity for youth to develop essential life skills such as leadership, teamwork, and resilience. Through engaging activities, inspiring talks, and interactive workshops, participants will grow both personally and spiritually. The supportive environment fosters friendships and connections that last a lifetime. Join us for a summer of growth, fun, and meaningful experiences that will empower you to become a compassionate and effective leader in your community.',
        image: img1,
             simg1:summerCamp_1,
             simg2:summerCamp_2,
             simg3:summerCamp_3,
        // },
    },
    {
        id: 'winter-camps',
        // icon: icon9,
        title:'Winter Camps',
        description: 'Focused support to help high school students excel in SAT prep and academics through targeted guidance and mentorship.',
        longDescription: 'Our Winter Camp provides a cozy and inspiring retreat for middle schoolers, high schoolers, and college students, even when the weather outside is freezing. This event focuses on building a strong spiritual foundation and enhancing leadership skills. Through a variety of indoor activities, warm gatherings, and engaging workshops, participants will experience personal and spiritual growth. The welcoming atmosphere ensures everyone feels comfortable and connected, creating lasting memories and friendships. Join us for a winter adventure filled with warmth, fun, and opportunities to develop into a confident and compassionate leader.',
        image: img2,
        simg1: winterCamp_3,
        simg2: winterCamp_1,
        simg3: winterCamp_2,
    },
      { id: 'tent-camps',
        // icon: icon9,
        title:'Tent Camps',
        description: 'Focused support to help high school students excel in SAT prep and academics through targeted guidance and mentorship.',
        longDescription: "Experience the great outdoors at our Tent Camp, where middle schoolers, high schoolers, and college students connect with nature while staying in tents. This unique event offers a chance to unplug from daily distractions and immerse in the beauty of the natural world. Participants will engage in activities that foster spiritual growth, teamwork, and leadership skills, all while enjoying the serene environment. Through hikes, campfires, and outdoor workshops, attendees will build lasting friendships and create unforgettable memories. Join us for a camping adventure that promotes personal development and a deeper appreciation for nature's wonders.",
        image: img3,
        simg1:tentCamp_1,
        simg2:tentCamp_2,
        simg3:tentCamp_3,
    },
      { id: 'mentor-training',
        icon: icon9,
        title:'Mentor Training',
        description: 'Supportive programs that help college student mentors grow through leadership training, skill-building workshops, and self-development retreats.',
        longDescription: "Our Mentor Development Programs equip college student mentors with the skills and personal growth opportunities needed for effective mentorship. Through immersive retreats, expert-led seminars, and interactive workshops, mentors enhance their leadership abilities, communication skills, and self-awareness. These programs foster a supportive community where mentors learn, reflect, and grow, ensuring they are well-prepared to guide and inspire their mentees. Join us to strengthen your mentorship skills and deepen your impact.",
        image: img3,
        simg1:mentorTrain,
        // simg2:tentCamp_2,
        // simg3:tentCamp_3,
    },
      {
        id: 'convention',
        icon: icon5,
        title: 'Conventions',
        description: 'Gatherings that unite college students to collaborate, develop leadership skills, and address global humanitarian challenges through workshops and discussions.',
        longDescription: 'Our Conventions bring together college students from all over the United States to connect, collaborate, and tackle pressing humanitarian issues. These gatherings provide a platform for young leaders to share ideas, network, and develop innovative solutions to problems facing humanity. Through a series of workshops, keynote speeches, and collaborative projects, participants enhance their leadership skills and deepen their understanding of global challenges. Our conventions foster a sense of community and inspire students to take collective action for positive change. Join us to be part of a dynamic and impactful event dedicated to making a difference in the world.',
        image: img1,
        simg1: convention_1,
            simg2:convention_2,
             simg3:convention_3,
        // },
    },
]
export default Services;